import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {CupCompetition, Division} from "@/modules/competitions/entity";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";
import KODivisionMatchGenerator from "@/modules/competitions/services/divisions/KODivisionMatchGenerator";
import CupCompetitionMatchdayGenerator from "@/modules/competitions/services/divisions/CupCompetitionMatchdayGenerator";

@injectable()
export class CupCompetitionSchedulingEventSubscriber implements EventSubscriber {
  constructor(
    @inject(CupCompetitionMatchdayGenerator) private cupCompetitionMatchdayGenerator: CupCompetitionMatchdayGenerator,
    @inject(KODivisionMatchGenerator) private koDivisionMatchGenerator: KODivisionMatchGenerator,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterSeasonEvaluationEvent, callback: this.afterSeasonEvaluationEvent},
    ];
  }

  async afterSeasonEvaluationEvent(event: AfterSeasonEvaluationEvent): Promise<void> {
    const competitions = await CupCompetition.find({
      relations: {
        divisions: true,
      }
    });

    await competitions.forEachAsync(async (competition: CupCompetition) => {
      console.debug(`start generating cup competition: ${competition.name}`);

      await competition.divisions.forEachAsync(async (d: Division) => {
        d.finished = false;
        await d.save();
      });

      await this.cupCompetitionMatchdayGenerator.generate(event.nextSeason, competition);
      await this.koDivisionMatchGenerator.generate(event.nextSeason, competition.divisions[0]);

      console.debug(`end generating cup competition: ${competition.name}`);
    });
  }
}